import {  createAsyncThunk } from '@reduxjs/toolkit';
import {API} from '../../axios/instance'

// Async thunk to login user
export const userLogin = createAsyncThunk('auth/userLogin', async (payload) => {
    const response = await API.post('auth/auth/login', payload);
    return response.data;
});


// Async thunk to register a new user
export const userRegister = createAsyncThunk('auth/userRegister', async (payload) => {
    const response = await API.post('auth/auth/register', payload);
    return response.data;
});

// Async thunk to fetch user profile details
export const fetchUserProfile = createAsyncThunk('auth/fetchUserProfile', async (userId) => {
    const response = await API.get(`auth/user/${userId}`);
    return response.data;
});

// Async thunk to update user profile
export const updateUserProfile = createAsyncThunk('auth/updateUserProfile', async (payload) => {
    const { userId, profileData } = payload; // payload could contain userId and the update data
    const response = await API.put(`auth/user/${userId}`, profileData);
    return response.data;
});

// Async thunk to logout user
export const userLogout = createAsyncThunk('auth/userLogout', async () => {
    const response = await API.post('auth/auth/logout');
    return response.data;
});

// Async thunk to refresh access tokens
export const refreshToken = createAsyncThunk('auth/refreshToken', async (refreshToken) => {
    const response = await API.post('auth/auth/refresh', { token: refreshToken });
    return response.data;
});